import React from 'react';
import './DesignPage.css'
import InquiryForm from '../components/InquiryForm'; // Adjust path as needed
import Process from '../components/StepProcess'; // Adjust path as needed
import useScrollToTop from '../components/useScrollToTop';
import ReusableLanding from '../components/ReusableLanding';
import image1 from '../img/px_img.avif';

const DesignPage = () => {
  useScrollToTop();
  return (
    <div>
      <ReusableLanding
        imageUrl={image1}
        title="Our Custom Home Design Process: Step-by-Step"
        description="Use Housekaar customized house designing services to design your dream home your way - fast, easy and affordably."
      />
      <Process />
      <InquiryForm />
    </div>
  );
};

export default DesignPage;